<template>
  <div class="modal" v-if="modalShown" v-drag="{handle:'#modal-moving'}" style="position: fixed">
    <div class="modal-main size-modal">
      <div class="title-area" id="modal-moving">
        <h2>選択パーツ設定</h2>
      </div>
      <div class="data-area">
        <!-- エラーメッセージ -->
        <div class="error_message">{{ errorMessage.text }}</div>
        <div class="error_message" v-if="this.validateErrorMessages && Object.keys(this.validateErrorMessages).length > 0">入力エラーがあります。</div>
        <!-- 選択パーツ一覧-->
        <p class="select-parts-type">
          通常・同期<span v-if="normalSynchroPartsList == null || Object.keys(normalSynchroPartsList).length <= 0">(該当なし)</span>
        </p>
        <div class="data-group" v-if="normalSynchroPartsList == null || Object.keys(normalSynchroPartsList).length <= 0">
        </div>
        <div class="data-group" v-for="(ptSetSelects, grpCode) in normalSynchroPartsList" :key="grpCode">
          <div v-for="(ptSetSelect, index) in ptSetSelects" :key="index">
            <input
              :id="'normal-synchro-' + grpCode + '-' + index"
              type="checkbox"
              :value="ptSetSelect.objNo"
              @change="changeParts($event, false, ptSetSelect.attString2, index)"
              :checked="ptSetSelect.objEnableFlag === 1"
            >
            <label :for="'normal-synchro-' + grpCode + '-' + index">
              {{ptSetSelect.attString1}}
            </label>
          </div>
        </div>
        <p class="select-parts-type">
          排他<span v-if="exclusionPartsList == null || Object.keys(exclusionPartsList).length <= 0">(該当なし)</span>
        </p>
        <div class="data-group" v-if="exclusionPartsList == null || Object.keys(exclusionPartsList).length <= 0">
        </div>
        <div class="data-group" v-for="(ptSetSelects, grpCode) in exclusionPartsList" :key="grpCode">
          <div v-for="(ptSetSelect, index) in ptSetSelects" :key="index">
            <input
              :id="'exclusion-' + grpCode + '-' + index"
              type="radio"
              :value="ptSetSelect.objNo"
              @change="changeParts($event, true, ptSetSelect.attString2, index)"
              :checked="ptSetSelect.objEnableFlag === 1"
            >
            <label :for="'exclusion-' + grpCode + '-' + index">
              {{ptSetSelect.attString1}}
            </label>
          </div>
        </div>
      </div>
      <!-- ボタンエリア -->
      <div class="button-area">
        <button type="button" class="main_btn" @click="closeModal">閉じる</button>
      </div>
    </div>
    </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import {PT_SET_SELECT} from '../../../constants/Type'
import * as Api from '../../../utils/Api'

export default {
  name: 'SetSelectParts',
  components: {
  },
  props: {
    /** ファイルデータ */
    fileData: Object,
    /** 編集操作用空間データ */
    editCtrlSpaces: Array,
    /** 構成メニューフォーカス空間 */
    focusedMenuSpace: Object,
    /** ユニット一つを選択しているかの判定値 */
    isOneUnitSelected: Boolean
  },
  data () {
    return {
      /** モーダル表示の判定 */
      modalShown: false,
      /* 通常・同期のパーツリスト */
      normalSynchroPartsList: {},
      /* 排他のパーツリスト */
      exclusionPartsList: {},
      /* 対象のユニットの空間ID */
      unitSpaceId: 0,
      /* 対象のジョインコード */
      destSpaceJoincd: '',
      /* エラーメッセージ */
      errorMessage: { text: '' },
      /* バリデーションエラーメッセージ */
      validateErrorMessages: {}
    }
  },
  watch: {
    modalShown: function () {
      /** キャンバス内キーボード制御 */
      if (this.modalShown) {
        this.$emit('onShowModal')
        document.addEventListener('keydown', this.onKeydown)
      } else {
        this.$emit('onCloseModal')
        document.removeEventListener('keydown', this.onKeydown)
      }
    }
  },
  computed: {
  },
  methods: {
    /** モーダル表示 */
    showModal: function () {
      this.$emit('showLoadingModal')

      if (!this.isOneUnitSelected && !this.focusedMenuSpace) {
        this.closeModal()
        this.$emit('closeLoadingModal')
        return
      }
      this.clearData()
      this.unitSpaceId = this.focusedMenuSpace != null ? this.focusedMenuSpace.id : this.editCtrlSpaces[0].id
      this.destSpaceJoincd = this.fileData.spaceJoincd
      this.getSelectPartsList()
    },
    /** モーダル非表示 */
    closeModal: function () {
      this.$emit('closeTreeContextModal')
      this.modalShown = false
      this.clearData()
    },
    /** データのクリア */
    clearData: function () {
      this.normalSynchroPartsList = {}
      this.exclusionPartsList = {}
      this.unitSpaceId = 0
      this.destSpaceJoincd = ''
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
    },
    /**
     * 選択パーツの変更
     * @param event イベント
     * @param isExclusion 排他であるかの判定値
     * @param grpCode グループコード
     * @param index グループコード内のインデックス番号
     */
    changeParts: function (event, isExclusion, grpCode, index) {
      // 画面の挙動に違和感があるため、ラジオをクリックしたらすぐにチェックが入るようにする
      if (isExclusion) {
        this.exclusionPartsList[grpCode][index]['objEnableFlag'] = 1
      } else {
        this.normalSynchroPartsList[grpCode][index]['objEnableFlag'] = 1
      }

      this.$emit('showLoadingModal')
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}

      let payload = {
        unitSpaceId: this.unitSpaceId,
        objEnableFlag: event.target.checked,
        partObjNo: event.target.value,
        destSpaceJoincd: this.destSpaceJoincd
      }
      axios.post(API_URL.PLANNING + '/set-select-parts', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.$emit('handleErrorMessage', response)
            return
          }
          this.$emit('setResponseData', response)
        }).catch(error => {
          this.$emit('closeLoadingModal')
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        }).finally(function () {
          this.getSelectPartsList()
        }.bind(this))
    },
    /**
     * 選択パーツの取得
     */
    getSelectPartsList: function () {
      axios.get(API_URL.PLANNING + '/get-select-parts/' + this.destSpaceJoincd + '/' + this.unitSpaceId)
        .then(response => {
          if (response.data.errorMessage) {
            this.$emit('handleErrorMessage', response)
            return
          }

          let normalSynchroPartsList = {}
          let exclusionPartsList = {}
          // 通常・同期と排他に分ける
          response.data.data.forEach(selectPartsProtocol => {
            let attributeModel = selectPartsProtocol.attributeModel
            let objectDataModel = selectPartsProtocol.objectDataModel
            attributeModel['objEnableFlag'] = objectDataModel.objEnableFlag
            attributeModel['objNo'] = objectDataModel.objNo

            switch (attributeModel.attValue2) {
              // 通常・同期
              case PT_SET_SELECT.NORMAL:
              case PT_SET_SELECT.SYNCHRO:
                if (normalSynchroPartsList[attributeModel.attString2]) {
                  normalSynchroPartsList[attributeModel.attString2] = [...normalSynchroPartsList[attributeModel.attString2], ...[attributeModel]]
                } else {
                  normalSynchroPartsList[attributeModel.attString2] = [attributeModel]
                }
                break
              // 排他
              case PT_SET_SELECT.EXCLUSION:
                if (exclusionPartsList[attributeModel.attString2]) {
                  exclusionPartsList[attributeModel.attString2] = [...exclusionPartsList[attributeModel.attString2], ...[attributeModel]]
                } else {
                  exclusionPartsList[attributeModel.attString2] = [attributeModel]
                }
                break
              default:
                break
            }
          })
          this.normalSynchroPartsList = Object.assign({}, normalSynchroPartsList)
          this.exclusionPartsList = Object.assign({}, exclusionPartsList)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        }).finally(function () {
          this.$emit('closeLoadingModal')
          this.modalShown = true
        }.bind(this))
    }
  }
}
</script>
<style lang="scss" scoped>
.size-modal {
  max-height: 700px;
}
.data-area {
  min-height: 300px;
  margin: 20px auto;
  max-height: 500px;
  overflow-y: auto;
  .select-parts-type {
    margin-bottom: 10px
  }
  .data-group {
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #333333;
    text-align: left;
  }
}
.error_message {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/modal/SetSelectParts.vue